import React from 'react';
import Modal from 'react-bootstrap/Modal';
import TextButton from 'components/TextButton';
import CloseIcon from 'resources/Icon-Close-Btn.svg';
import SetUpAvatar from './SetUpAvatar';
import './EditAvatarModal.scss';

const EditAvatarModal = props => {
  return (
    <Modal
      show={props.showEditAvatarModal}
      onHide={() => {
        props.hideEditAvatar();
      }}
      className="modal-dialog-edit-avatar-modal"
      backdrop={'static'}
    >
      <Modal.Body>
        <SetUpAvatar {...props} />
      </Modal.Body>
      <div className="dialog-close-button">
        <TextButton
          onClick={() => {
            props.hideEditAvatar();
          }}
        >
          <img src={CloseIcon} alt="Close Dialog" />
        </TextButton>
      </div>
    </Modal>
  );
};

export default EditAvatarModal;
